import React from "react";
import PropTypes from "prop-types";

class AccordionRadio extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  handletoFetchCycleIdChange(e) {
    if (typeof this.props.onChange === "function")
      return this.props.onChange(e);
  }

  render() {
    const { children, cycleId, cycleName, programsCount } = this.props;
    const { viewChildren } = this.state;

    return (
      <div className="Cycle-Accordion">
        <input
          name="toFetchCycleId"
          type="radio"
          checked={!!cycleId}
          onChange={(e) => this.handletoFetchCycleIdChange(e)}
          id={cycleId}
        />

        <div className="head">
          <h5>{cycleName}</h5>
          {/* <label className="radio-input" htmlFor={cycleId}>
           
            
          </label> */}
        </div>

        <div className="programs">{children}</div>
      </div>
    );
  }
}

AccordionRadio.contextTypes = { locals: PropTypes.object };

export default AccordionRadio;
